import Dad1 from "../../images/giftcards/1dad.webp";
import FiftyYears from "../../images/giftcards/50years.webp";
import AllTogetherNow from "../../images/giftcards/all-together-now.webp";
import Besties from "../../images/giftcards/besties.webp";
import BirthdayCandle from "../../images/giftcards/birthday-candle.webp";
import BirthdayVibe from "../../images/giftcards/birthday-vibe.webp";
import CoffeeGoodIdea from "../../images/giftcards/coffee-good-idea.webp";
import Congrats from "../../images/giftcards/congrats.webp";
import CouldntWithoutYou from "../../images/giftcards/couldnt-without-you.webp";
import ExtraShotOfPride from "../../images/giftcards/extra-shot-of-pride.webp";
import FathersDay from "../../images/giftcards/fathers-day.webp";
import FavoritePerson from "../../images/giftcards/favorite-person.webp";
import FriendForever from "../../images/giftcards/friend-forever.webp";
import GladYouWereBorn from "../../images/giftcards/glad-you-were-born.webp";
import GoodThingsAhead from "../../images/giftcards/good-things-ahead.webp";
import HappyBirthday from "../../images/giftcards/happy-birthday.webp";
import HappyBirthday2 from "../../images/giftcards/happy-birthday2.webp";
import HappyFathersDay from "../../images/giftcards/happy-fathers-day.webp";
import LoveYouAll from "../../images/giftcards/love-you-all.webp";
import MyHero from "../../images/giftcards/my-hero.webp";
import MyTreat from "../../images/giftcards/my-treat.webp";
import Pride from "../../images/giftcards/pride.webp";
import SkyTheLimit from "../../images/giftcards/sky-the-limit.webp";
import ThankGoodnessForYou from "../../images/giftcards/thank-goodness-for-you.webp";
import ThankYou from "../../images/giftcards/thank-you.webp";
import ThisOneOnMe from "../../images/giftcards/this-one-on-me.webp";
import Unstoppable from "../../images/giftcards/unstoppable.webp";
import WayToGo from "../../images/giftcards/way-to-go.webp";
import Yay from "../../images/giftcards/yay.webp";
import YouAreBestest from "../../images/giftcards/you-are-bestest.webp";
import YouAreMyFave from "../../images/giftcards/you-are-my-fave.webp";
import YouTakeCareOfUs from "../../images/giftcards/you-takecare-of-us.webp";
import NotWithoutYou from "../../images/giftcards/not-without-you.webp";
import ThankYouTeacher from "../../images/giftcards/thank-you-teacher.webp";
import YouAmazeMe from "../../images/giftcards/you-amaze-me.webp";
import YouAreWonderful from "../../images/giftcards/you-areWonderful.webp";
import YesQueen from "../../images/giftcards/yes-queen.webp";
import BestTeacherEver from "../../images/giftcards/best-teacher-ever.webp";
import YouGetA from "../../images/giftcards/you-get-A.webp";
import LoveYouGirl from "../../images/giftcards/love-youGirl.webp";
import YouAreHere from "../../images/giftcards/you-are-here.webp";
import OverTheMoon from "../../images/giftcards/over-theMoon.webp";
import HeartYouSoMuch from "../../images/giftcards/heartYouSoMuch.webp";
import ThanksForGivingYouAll from "../../images/giftcards/giving-yourAll.webp";
import YourHardWorkNoticed from "../../images/giftcards/your-hardWorkNoticed.webp";
import YouAreAmazing from "../../images/giftcards/you-areAmazing.webp";
import HangInThere from "../../images/giftcards/hangInthere.webp";
import FriendByFriendCoffee from "../../images/giftcards/friend-by-friend-coffee.webp";
import PositiveEnergy from "../../images/giftcards/you-areAmazing.webp";
import HighFive from "../../images/giftcards/high-five.webp";
import ServiceGratitude from "../../images/giftcards/service-gratitude.webp";
import ThankYouForAllYouDo from "../../images/giftcards/thank-you-forAllYouDo.webp";
import StarbuckAnyTimeGiftCard1 from "../../images/giftcards/starbuck-giftcard.webp";
import StarbuckAnyTimeGiftCard2 from "../../images/giftcards/anytime-giftcard1.webp";
import StarbuckAnyTimeGiftCard3 from "../../images/giftcards/anytime-giftcard3.webp";

const featuredGiftCard = [
	<img src={FiftyYears} alt="fifty year gift card" />,
	<img src={BirthdayCandle} alt="birthday gift card" />,
	<img src={CouldntWithoutYou} alt="couldn't without you gift card" />,
	<img src={HappyFathersDay} alt="happy father's day gift card" />,
	<img src={GoodThingsAhead} alt="good things ahead gift card" />,
	<img src={NotWithoutYou} alt="i'm not without you gift card" />,
	<img src={Pride} alt="pride gift card" />,
	<img src={SkyTheLimit} alt="the sky is the limit gift card" />,
	<img src={YouTakeCareOfUs} alt="you take care of us gift card" />,
	<img src={ThankYouTeacher} alt="thank you teacher gift card" />,
	<img src={GoodThingsAhead} alt="encouragement gift card" />,
	<img src={CoffeeGoodIdea} alt="encouragement gift card" />,
	<img src={HangInThere} alt="encouragement gift card" />,
	<img src={FriendByFriendCoffee} alt="encouragement gift card" />,
	<img src={PositiveEnergy} alt="encouragement gift card" />,
	<img src={YouAmazeMe} alt="appreciation gift card" />,
	<img src={YouAreWonderful} alt="appreciation gift card" />,
	<img src={YouAreBestest} alt="appreciation gift card" />,
	<img src={YesQueen} alt="appreciation gift card" />,
	<img src={Yay} alt="appreciation gift card" />,
	<img src={ExtraShotOfPride} alt="pride gift card" />,
	<img src={LoveYouAll} alt="love you all gift card" />,
	<img src={AllTogetherNow} alt="pride gift card" />,
	<img src={MyTreat} alt="pride gift card" />,
	<img src={Unstoppable} alt="unstoppable gift card" />,
	<img src={Congrats} alt="congrats gift card" />,
	<img src={WayToGo} alt="way to go gift card" />,
	<img src={ThankGoodnessForYou} alt="way to go gift card" />,
	<img src={StarbuckAnyTimeGiftCard1} alt="gift you can buy for any occassion" />,
	<img src={StarbuckAnyTimeGiftCard2} alt="gift you can buy for any occassion" />,
	<img src={StarbuckAnyTimeGiftCard3} alt="gift you can buy for any occassion" />,
	<img src={ExtraShotOfPride} alt="community gift cards" />,
	<img src={ServiceGratitude} alt="community gift cards" />,
	<img src={ThankYouForAllYouDo} alt="community gift cards" />,
	<img src={Besties} alt="community gift cards" />,
	<img src={FriendForever} alt="community gift cards" />,
	<img src={YouAreMyFave} alt="community gift cards" />,
];

const fathersDayGiftCard = [
	<img src={FathersDay} alt=" happy father's day gift card" />,
	<img src={HappyFathersDay} alt="happy father's day gift card" />,
	<img src={Dad1} alt="number 1 dad gift card" />,
];

const thankYouGiftCard = [
	<img src={ThankGoodnessForYou} alt="thank goodness for you" />,
	<img src={ThankYou} alt="thank you gift card" />,
	<img src={MyTreat} alt="my treat gift card" />,
	<img src={YouAreBestest} alt="you are the bestest gift card" />,
	<img src={ThisOneOnMe} alt="this one is one me" />,
];

const birthdayGiftCard = [
	<img src={BirthdayCandle} alt="birthday gift card" />,
	<img src={GladYouWereBorn} alt="glad you were born gift card" />,
	<img src={BirthdayVibe} alt="birthday vibe" />,
	<img src={HappyBirthday2} alt="happy birthday card" />,
	<img src={HappyBirthday} alt="happy birthday gift card" />,
];

const graduationGiftCard = [
	<img src={SkyTheLimit} alt="the sky is the limit" />,
	<img src={Unstoppable} alt="unstoppable gift card" />,
	<img src={Congrats} alt="congrats gift card" />,
	<img src={WayToGo} alt="way to go gift card" />,
	<img src={ThankGoodnessForYou} alt="way to go gift card" />,
];

const prideGiftCard = [
	<img src={Pride} alt="pride gift card" />,
	<img src={ExtraShotOfPride} alt="pride gift card" />,
	<img src={LoveYouAll} alt="love you all gift card" />,
	<img src={AllTogetherNow} alt="pride gift card" />,
	<img src={MyTreat} alt="pride gift card" />,
];

const appreciationGiftCard = [
	<img src={YouAmazeMe} alt="appreciation gift card" />,
	<img src={YouAreWonderful} alt="appreciation gift card" />,
	<img src={YouAreBestest} alt="appreciation gift card" />,
	<img src={YesQueen} alt="appreciation gift card" />,
	<img src={Yay} alt="appreciation gift card" />,
	<img src={ThankYouForAllYouDo} alt="community gift cards" />,
];

const teacherAppreciationGiftCard = [
	<img src={BestTeacherEver} alt="teacher appreciation gift card" />,
	<img src={ThankYouTeacher} alt="teacher appreciation gift card" />,
	<img src={YouGetA} alt="teacher appreciation gift card" />,
];

const loveGiftCard = [
	<img src={NotWithoutYou} alt="love gift card" />,
	<img src={LoveYouGirl} alt="love gift card" />,
	<img src={YouAreHere} alt="love gift card" />,
	<img src={OverTheMoon} alt="love gift card" />,
	<img src={HeartYouSoMuch} alt="love gift card" />,
];

const recognitonGiftCard = [
	<img src={YouTakeCareOfUs} alt="recognition gift card" />,
	<img src={MyHero} alt="recognition gift card" />,
	<img src={ThanksForGivingYouAll} alt="recognition gift card" />,
	<img src={YourHardWorkNoticed} alt="recognition gift card" />,
	<img src={YouAreAmazing} alt="recognition gift card" />,
];

const encouragementGiftCard = [
	<img src={GoodThingsAhead} alt="encouragement gift card" />,
	<img src={CoffeeGoodIdea} alt="encouragement gift card" />,
	<img src={HangInThere} alt="encouragement gift card" />,
	<img src={FriendByFriendCoffee} alt="encouragement gift card" />,
	<img src={PositiveEnergy} alt="encouragement gift card" />,
];

const workplaceGiftCard = [
	<img src={CouldntWithoutYou} alt="workplace gift cards" />,
	<img src={HighFive} alt="workplace gift cards" />,
	<img src={YourHardWorkNoticed} alt="workplace gift cards" />,
	<img src={WayToGo} alt="workplace gift cards" />,
	<img src={FavoritePerson} alt="workplace gift cards" />,
];

const anniversaryGiftCard = [<img src={FiftyYears} alt="fifty years anniversary card" />];

const communityGiftCard = [
	<img src={ExtraShotOfPride} alt="community gift cards" />,
	<img src={LoveYouAll} alt="community gift cards" />,
	<img src={ServiceGratitude} alt="community gift cards" />,
	<img src={ThankYouForAllYouDo} alt="community gift cards" />,
	<img src={CouldntWithoutYou} alt="community gift cards" />,
];

const anyTimeGiftCard = [
	<img src={StarbuckAnyTimeGiftCard1} alt="gift you can buy for any occassion" />,
	<img src={StarbuckAnyTimeGiftCard2} alt="gift you can buy for any occassion" />,
	<img src={StarbuckAnyTimeGiftCard3} alt="gift you can buy for any occassion" />,
];

const giftCardContent = {
	featuredGiftCard,
	fathersDayGiftCard,
	thankYouGiftCard,
	birthdayGiftCard,
	graduationGiftCard,
	prideGiftCard,
	appreciationGiftCard,
	teacherAppreciationGiftCard,
	loveGiftCard,
	recognitonGiftCard,
	encouragementGiftCard,
	workplaceGiftCard,
	anniversaryGiftCard,
	communityGiftCard,
	anyTimeGiftCard,
};
export default giftCardContent;
